import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableVehiculeDetailsPage = withAsyncLoading(async () =>
    import('./VehiculeDetailsPage').then((res) => res.VehiculeDetailsPage)
);

export { LoadableVehiculeDetailsPage };
